import { useEffect, useState } from 'react';

import { useCountriesQuery } from '@/graphql/generated';

import { defaultCountryCodeValues, getDialCodeFromCountryCode } from '../../helpers';

type Country = {
  name: string;
  dialCode: string;
  countryCode: string;
};

type UseCountriesResult = Country[];

export const useCountries = (): UseCountriesResult => {
  const [countries, setCountries] = useState<Country[]>(defaultCountryCodeValues);
  const { data } = useCountriesQuery();

  useEffect(() => {
    const updatedCountries = data?.countries
      ?.map((country) =>
        getDialCodeFromCountryCode(country.countryCode) !== undefined
          ? {
              name: country.name,
              dialCode: getDialCodeFromCountryCode(country.countryCode),
              countryCode: country.countryCode,
            }
          : undefined
      )
      .filter(Boolean);

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    updatedCountries && setCountries(updatedCountries as Country[]);
  }, [data]);

  return countries;
};
